import DefaultMainPage from "../../../pages/DefaultMainPage";
import PassManager from "./PassManager";
import PassTable from "./PassTable";
import {PASS_TYPE} from "../../../shared/utils/enum";

const passMasterMenuItems = [
    {path: "/passMaster", component: <PassManager passType={PASS_TYPE.MONTHLY}/>, label: '시즌 패스'},
    {path: "/passMaster/weekly", component: <PassManager passType={PASS_TYPE.WEEKLY}/>, label: '주간 패스'},
    {path: "/passMaster/table", component: <PassTable/>, label: '패스 마스터'},
];

export const passMasterRoutes = {
    path: "/passMaster",
    component: <DefaultMainPage buttons={passMasterMenuItems}/>,
    children: passMasterMenuItems
}